import React, { useState } from 'react';

import { APIROOT } from '../../Helpers/configs';
import SerialAddHistory from './SerialAddHistory';
import { GetAuth } from '../../Auth/AuthProvider';
import { defineTicketNumberV3 } from '../../Helpers/helpers';
import { convertDate } from '../../Helpers/dateHelpers';

import SerialTicketHistoryView from './SerialTicketHistoryView';

import Card from '@mui/material/Card';
import { Modal, Button, Box } from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
// import { useNavigate } from 'react-router-dom';

// function createData(serialId, tickeNumber, date, technician, description) {
//   return { serialId, tickeNumber, date, technician, description };
// }

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  borderRadius: 2,
  p: '1px 1px 1px  10px ',
};
const style2 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  borderRadius: 2,
  p: '1px 1px 1px  1px ',
};

function SerialHistoryList(props) {
  const enqNotification = GetAuth().Notification;
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openTicket, setOpenTicket] = React.useState(false);
  const OpenTicket = () => setOpenTicket(true);
  const CloseTicket = () => setOpenTicket(false);
  const [counter, setCounter] = useState(0);

  // const [newValue, forceUpdate] = useReducer((x) => x + 1, 0);
  const [history, setHistory] = React.useState([]);
  const currentSerialId = props.serialInfo.id;

  const [ticketViewHistory, setTicketViewHistory] = useState({});

  React.useEffect(() => {
    fetchHistory(currentSerialId, setHistory);
  }, [counter]);

  // const serialListId = props.serialInfo.id;

  const handleOpenTicket = (rowData) => {
    setTicketViewHistory(rowData);
    if (rowData.legacy_ticket === '1') {
      enqNotification('No history data for Legacy Tickets', 'info');
      return;
    } else {
      OpenTicket();
    }
  };

  return (
    <Card style={{ margin: '15px 0', padding: 0 }}>
      <Grid
        container
        rowSpacing={0}
        columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        style={{
          // background: '#84a1bc91',
          background: 'rgb(235, 237, 248)',
          height: 'auto',
          // borderRadius: 15,
          padding: '5px 10px 5px 20px',
        }}
      >
        <Grid item xs={12} md={12}>
          <Typography variant='h5'>Ticket History</Typography>
        </Grid>
        <Grid>
          <Button
            sx={{ margin: 2 }}
            variant='contained'
            onClick={() => {
              handleOpen();
              // console.log(props.serialInfo);
            }}
          >
            Create Entry
          </Button>

          <Button
            sx={{ margin: 2 }}
            variant='outlined'
            onClick={() => {
              fetchHistory(currentSerialId, setHistory);
            }}
          >
            Refresh
          </Button>
        </Grid>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size='small' aria-label='a dense table'>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    background: '#4caf50',
                    color: '#fff',
                    border: '1 solid ',
                    fontWeight: 'bold',
                  }}
                >
                  Ticket Number
                </TableCell>
                <TableCell
                  style={{
                    background: '#4caf50',
                    color: '#fff',
                    border: '1 solid ',
                    fontWeight: 'bold',
                  }}
                  align='right'
                >
                  Date
                </TableCell>
                <TableCell
                  style={{
                    background: '#4caf50',
                    color: '#fff',
                    border: '1 solid ',
                    fontWeight: 'bold',
                  }}
                  align='right'
                >
                  Technician
                </TableCell>
                <TableCell
                  style={{
                    background: '#4caf50',
                    color: '#fff',
                    border: '1 solid ',
                    fontWeight: 'bold',
                  }}
                  align='right'
                >
                  Description
                </TableCell>
                <TableCell
                  style={{
                    background: '#4caf50',
                    color: '#fff',
                    border: '1 solid ',
                    fontWeight: 'bold',
                  }}
                  align='right'
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component='th' scope='row'>
                    {row.legacy_ticket === '1'
                      ? row.ticket_meta
                      : defineTicketNumberV3(
                          row?.ticket_type,
                          row.ticket_id,
                          5
                        )}
                  </TableCell>
                  <TableCell align='right'>
                    {convertDate(row.ticket_date, 0, 10)}
                  </TableCell>
                  <TableCell align='right'>{row.installer_name}</TableCell>
                  <TableCell align='right'>{row.description}</TableCell>
                  <TableCell align='right'>
                    <Button
                      size='small'
                      variant='outlined'
                      onClick={() => {
                        handleOpenTicket(row);
                      }}
                    >
                      View Ticket
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <SerialAddHistory
            forceUpdate={setCounter}
            closeModel={handleClose}
            serialId={props.serialInfo.id}
          />
        </Box>
      </Modal>
      <Modal
        open={openTicket}
        onClose={CloseTicket}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style2}>
          <SerialTicketHistoryView
            closeModel={CloseTicket}
            ticketInfo={ticketViewHistory}
          />
        </Box>
      </Modal>
    </Card>
  );
}

export default SerialHistoryList;

function fetchHistory(serialID, setDataFunc) {
  //Get JWT from storage
  let JWT = localStorage.getItem('JWT_Key');

  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const request = new Request(
    `${APIROOT}/api/serialnumberhistory/${serialID}`,
    { method: 'POST', headers: headers }
  );

  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);
      if (parsed.success === true) {
        setDataFunc(parsed.data.value);
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });
}
